import { css } from 'emotion'

export const UpdateUserDisplayNameFormStyles = css``
